import React from "react";
import { Dropdown } from "@culturehq/components";
import { Trans } from "app/utils";

const options = [
  { value: "culture_page", label: "Culture page" },
  { value: "carousel", label: "Carousel" },
  { value: "single_story_page", label: "Single story page" }
];

const ChannelFilter = ({ type, onChange }) => {
  const selectedLabel = options.find(option => option.value === type)?.label;

  return (
    <Dropdown selected={type || "all"} onChange={value => onChange("type", value)}>
      <Dropdown.Button className="chq-btn Gray-Button">
        <Trans>{selectedLabel}</Trans>
      </Dropdown.Button>
      <Dropdown.ListBox className="custom_option dp-ehg">
        {options.map(option => (
          <Dropdown.Option key={option.value} value={option.value}>
            <Trans>{option.label}</Trans>
          </Dropdown.Option>
        ))}
      </Dropdown.ListBox>
    </Dropdown>
  );
};

export default ChannelFilter;
